(() => {
  if (window.__hckCountdownControllerReady) return;
  window.__hckCountdownControllerReady = true;

  const SELECTOR = '.hck-countdown-overlay[data-end-time]';

  function pad(value) {
    return String(Math.max(0, value)).padStart(2, '0');
  }

  function hideCountdown(countdown) {
    countdown.hidden = true;
    countdown.setAttribute('aria-hidden', 'true');
    countdown.closest('.m-hero')?.classList.add('hck-countdown--inactive');
  }

  function showTitleOnly(countdown, titleText) {
    const titleElement = countdown.querySelector('[data-countdown-title]');

    countdown.closest('.m-hero')?.classList.remove('hck-countdown--inactive');
    countdown.classList.add('hck-countdown-overlay--expired-message');
    if (titleElement && titleText) {
      titleElement.textContent = titleText;
      titleElement.hidden = false;
    } else {
      hideCountdown(countdown);
    }
  }

  function handleMissingDate(countdown) {
    countdown.classList.add('hck-countdown-overlay--no-date');

    if (countdown.dataset.emptyBehavior === 'hide') {
      hideCountdown(countdown);
    }
  }

  function handleExpiredCountdown(countdown, elements) {
    const behavior = countdown.dataset.expiredBehavior || 'hide';

    elements.forEach(element => {
      element.textContent = '00';
    });

    countdown.classList.add('hck-countdown-overlay--expired');

    if (behavior === 'hide') {
      hideCountdown(countdown);
      return;
    }

    if (behavior === 'message') {
      showTitleOnly(
        countdown,
        countdown.dataset.expiredText || 'EVENT ENDED'
      );
    }
  }

  function initializeCountdown(countdown) {
    if (countdown.dataset.countdownInitialized === 'true') return;

    const endTimeValue = countdown.dataset.endTime.trim();
    if (!endTimeValue) {
      countdown.dataset.countdownInitialized = 'true';
      handleMissingDate(countdown);
      return;
    }

    const endTime = new Date(endTimeValue).getTime();
    if (Number.isNaN(endTime)) {
      countdown.dataset.countdownInitialized = 'true';
      handleMissingDate(countdown);
      return;
    }

    const elements = [
      countdown.querySelector('[data-days]'),
      countdown.querySelector('[data-hours]'),
      countdown.querySelector('[data-minutes]'),
      countdown.querySelector('[data-seconds]')
    ];

    if (elements.some(element => !element)) return;

    countdown.dataset.countdownInitialized = 'true';

    function updateCountdown() {
      const remaining = endTime - Date.now();

      if (remaining <= 0) {
        handleExpiredCountdown(countdown, elements);
        clearInterval(countdown._hckTimer);
        countdown._hckTimer = null;
        return;
      }

      const days = Math.floor(remaining / 86400000);
      const hours = Math.floor((remaining % 86400000) / 3600000);
      const minutes = Math.floor((remaining % 3600000) / 60000);
      const seconds = Math.floor((remaining % 60000) / 1000);

      elements[0].textContent = pad(days);
      elements[1].textContent = pad(hours);
      elements[2].textContent = pad(minutes);
      elements[3].textContent = pad(seconds);
    }

    updateCountdown();
    if (!countdown.hidden) {
      countdown._hckTimer = setInterval(updateCountdown, 1000);
    }
  }

  function initializeAllCountdowns(root = document) {
    root.querySelectorAll(SELECTOR).forEach(initializeCountdown);
  }

  function clearCountdowns(root) {
    root.querySelectorAll(SELECTOR).forEach(countdown => {
      if (countdown._hckTimer) {
        clearInterval(countdown._hckTimer);
        countdown._hckTimer = null;
      }
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    initializeAllCountdowns();
  });

  document.addEventListener('shopify:section:load', event => {
    initializeAllCountdowns(event.target);
  });

  document.addEventListener('shopify:section:unload', event => {
    clearCountdowns(event.target);
  });

  initializeAllCountdowns();
})();
